import React, { useState, useEffect } from "react";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthContinue } from "../misc/auth-continue.component";
import { AuthRestartButton } from "../misc/restart-button.component";
import { Field, reduxForm } from "redux-form";
import AuthDebitFields from "./field-components/general/auth-debit-fields.component";
import { generateLoanDescription } from "../misc/messaging-utils";
import { renderSelectField } from "../../../utils/renderField";
import { required } from "../../../utils/formValidators";
import Show from "../../../utils/show.component";
import SkipMonthSelectFields from "./field-components/general/skip-month-select-fields.component";
import { constructDebitRequest, usd } from "../../../utils/utils";
import InternalSkipAccounts from "./field-components/general/internal-skip-accounts.component";
import moment from "moment";
import { authVerifySkipPayment } from "../../../utils/requests";

const AuthSkipAPayForm = (props) => {
  // Just use the existing internal accounts response for now
  const internalAccounts = props.authPayment.internalAccounts;

  const skipInfo = props.authPayment.selectedLoanSkipInfo;
  const additionalAmount =
    skipInfo.AmountToBringCurrentInfo.Balance < 0
      ? Math.abs(skipInfo.AmountToBringCurrentInfo.Balance)
      : 0;

  const syncErrors = props.thisForm && props.thisForm.syncErrors;
  const values = props.thisForm && props.thisForm.values;

  const feeAmount = values && values.skipTwoMonths === "true" ? 70 : 35;

  const skipPaymentMethod = values && values.skipPaymentMethod;

  const combinedFeeAmount =
    skipPaymentMethod === "Debit Card" ? feeAmount + additionalAmount : feeAmount;

  const validAccounts = internalAccounts.filter(
    (account) => account.AvailableBalance >= feeAmount && account.ValidForSkips
  );
  const skipDebitResponse = props.authPayment.skipDebitResponse;

  const eligibleSkipDates = props.authPayment.selectedLoanSkipInfo.SkippableDueDates;

  const requiredDebitFields = [
    "nameOnCard",
    "account_nbr",
    "exp_date",
    "cvv2",
    "zip_code",
    "skipPaymentMethod",
    "skipTwoMonths",
  ];

  const requiredInternalFields = ["AccountHash", "skipPaymentMethod", "skipTwoMonths"];

  // Function to selectively check syncErrors depending on payment method in order to disable/enable the continue button accordingly
  const hasMethodSyncErrors = () => {
    let hasErrors = false;

    if (syncErrors) {
      const requiredFields =
        skipPaymentMethod === "Debit Card" ? requiredDebitFields : requiredInternalFields;

      requiredFields.forEach((field) => {
        if (syncErrors[field]) {
          hasErrors = true;
        }
      });
    }

    // Block internal transfers in the case the user has not selected an account
    // or there are no valid accounts
    if (skipPaymentMethod === "Lake Trust Account" && !values.AccountHash) {
      hasErrors = true;
    }

    return hasErrors;
  };

  const advanceCallback = () => {
    props.callGetCardType(values.account_nbr);
    props.setProcessStep(2);
  };

  const submitForm = () => {
    window.scrollTo(0, 0);

      if (skipPaymentMethod === "Debit Card") {
          // Sanity check. If debit card is chosen, set the accounthash to null so the primary savings account will be used for the fee
          values.AccountHash = null;
      // Verify all debit payments before advancing screens and getting card type
      
      const paymentDetails = constructDebitRequest(values, combinedFeeAmount, skipPaymentMethod);

      const fullDetails = {
        Payment: paymentDetails,
      }

      props.dispatch({
        type: "AUTH_VERIFY_SKIP_PAYMENT",
        paymentDetails: fullDetails,
        advanceCallback,
      })
    } else {
         props.setProcessStep(2); 
    }
  };

  useEffect(() => {
    props.change("AccountHash", "");
  }, [feeAmount]);

  return (
    <AuthPaymentContainer title="Skip-A-Pay">
      <form onSubmit={props.handleSubmit(submitForm)}>
        <div className="bold f20">{generateLoanDescription(props.selectedLoan, false)}</div>
        <div className="my-4 divider" />
        <Show condition={skipPaymentMethod === "Debit Card" && additionalAmount}>
          <div className="payment-warning f14 p-3 mt-2">
            Your Membership Savings account currently has a negative available balance of{" "}
            {usd.format(additionalAmount)}. The fee amount below includes{" "}
            {usd.format(additionalAmount)} to bring your account to good standing.
          </div>
        </Show>
        <SkipMonthSelectFields
          skippableDueDates={eligibleSkipDates}
          thisForm={props.thisForm}
          change={props.change}
        />
        <div className="pt-3">
          <div className="f18 bold">Total Fee Amount</div>
          <div className="f36 bold" style={{ color: "#00558c" }}>
            {usd.format(combinedFeeAmount)}
          </div>
        </div>
        <div className="my-4 divider" />
        <div className="pt-4 f18 bold">Choose Payment Type</div>
        <div className="mb-4">Pay with debit card or a Lake Trust account.</div>
        <Field
          label="Payment Type"
          id="skipPaymentMethodSelect"
          name="skipPaymentMethod"
          component={renderSelectField}
          options={["Debit Card", "Lake Trust Account"]}
          validate={[required]}
          showSelectOption={false}
          type="text"
        />
        <Show condition={skipPaymentMethod === "Debit Card"}>
          <AuthDebitFields />
        </Show>
        <Show condition={skipPaymentMethod === "Lake Trust Account"}>
          <div className="pt-4" />
          <InternalSkipAccounts
            accounts={validAccounts}
            thisForm={props.thisForm}
            change={props.change}
          />
        </Show>
        <AuthContinue
          title="Continue"
          type="submit"
          disabled={props.submitting || hasMethodSyncErrors()}
        />
        <AuthRestartButton backToLoans={props.backToLoans} />
      </form>
    </AuthPaymentContainer>
  );
};

//Connect to Redux store
export const AuthSkipAPay = reduxForm({
  form: "SkipAPay",
  destroyOnUnmount: false,
  initialValues: {
    nameOnCard: null,
    account_nbr: null,
    exp_date: null,
    cvv2: null,
    zip_code: null,
    AccountHash: null,
    skipPaymentMethod: "Debit Card",
    skipTwoMonths: "false",
  },
})(AuthSkipAPayForm);



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/auth-skip-a-pay-form.component.js